import script from "./workflow-review-status-screen.vue?vue&type=script&setup=true&lang=ts"
export * from "./workflow-review-status-screen.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__